import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Modal, { ModalTypePropKeys } from "../UI/Modal/Modal";
// @ts-expect-error - TS2339 - Property 'filter' does not exist on type 'keyof ModalProps[]'.
const ModalPropKeysWithoutChildren = ModalTypePropKeys.filter(
// @ts-expect-error - TS7006 - Parameter 'key' implicitly has an 'any' type.
(key) => key !== "children");
export default function withModal(Comp, options) {
    // eslint-disable-next-line react/display-name,func-names
    return function (props) {
        const modalProps = ModalPropKeysWithoutChildren.concat(options.extraModalPropKeys).reduce(
        // @ts-expect-error - TS7006 - Parameter 'mProps' implicitly has an 'any' type.
        (mProps, key) => 
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'ModalPropsWithoutChildren'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'ModalPropsWithoutChildren'.
        props[key] != null ? Object.assign(Object.assign({}, mProps), { [key]: props[key] }) : mProps, {});
        return (_jsx(Modal, Object.assign({}, options.defaultModalProps, modalProps, { children: _jsx(Comp, Object.assign({}, options.defaultModalProps, props)) })));
    };
}
